import {useEffect, useState} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {CheckWrapper, SelectWrapper} from '../../../../../../components/UI/Form/Input'
import InputNumberWrapper2 from '../../../../../../components/UI/Form/Input/numberWrapper2'
import {useLimpieza} from '../../../../../../hooks/useLimpieza'
import {TabLimpiezaModel} from '../../../../../../models'
import {useCampaments} from '../../../../hooks/central/useCampaments'
import {useClients} from '../../../../hooks/central/useClients'
import {useCompanies} from '../../../../hooks/central/useCompanies'
import {useParameters} from '../../../../hooks/central/useParameters'
import {useSites} from '../../../../hooks/central/useSites'
import {useModules} from '../../../../hooks/hoteleria/useModules'
import {useRooms} from '../../../../hooks/hoteleria/useRooms'
import {CREATION_CLEANING_ACTIVITIES_SERVICES} from '../../../../services/creation-cleaning-activities.service'

export const CreationCleaningActivitiesForm = () => {
  const allValue = '4EsB2NAAsDA='
  const {setError, setValue, watch} = useFormContext()
  const {currentTabItem, changeCurrentTabItem} = useLimpieza()
  const {getCompanies, companies, clearCompanies} = useCompanies()
  const {getClients, clients, clearClients} = useClients()
  const {getSites, sites, clearSites} = useSites()
  const {getCampaments, campaments, clearCampaments} = useCampaments()
  const {getModules, modules, clearModules} = useModules()
  const {getRooms, clearRooms} = useRooms()
  const {
    cleaningActivities,
    getCleaningActivities,
    typeActions,
    getTypeActions,
    typeBuildings,
    getTypeBuildings,
    cleaningActivitiesStatus,
    getCleaningActivitiesStatus,
  } = useParameters()

  const inicioFin = typeActions.find((ta) => ta.label === 'INICIO FIN')
  const ingreso = typeActions.find((ta) => ta.label === 'INGRESO')
  const salida = typeActions.find((ta) => ta.label === 'SALIDA')
  const ingresoSalida = typeActions.find((ta) => ta.label === 'INGRESO SALIDA')
  const activeStatus = cleaningActivitiesStatus.find((ta) => ta.label === 'ACTIVO')
  const moduloBuilding = typeBuildings.find((tb) => tb.label === 'MODULO')

  const typeActionWatch = useWatch({
    name: 'TipoAccionId',
  })
  const siteId = useWatch({
    name: 'SiteId',
  })

  const [typeActionStart, setTypeActionStart] = useState<boolean>(false)
  const [showFieldsStart, setShowFieldsStart] = useState<boolean>(false)
  const [allTypes, setAllTypes] = useState(false)

  useEffect(() => {
    getCompanies({isCombo: true}, 1)
    getCleaningActivities(
      {pageNumber: 1, size: 200, tableName: 'ACTIVIDADLIMPIEZA'},
      {},
      {idKey: 'id', labelKey: 'nombreCorto'},
      {all: true, value: allValue, label: 'TODOS'},
    )
    getTypeActions(
      {pageNumber: 1, size: 200, tableName: 'TIPOACCION'},
      {},
      {idKey: 'id', labelKey: 'nombreCorto'},
      {all: true, value: allValue, label: 'TODOS'},
    )
    getTypeBuildings({pageNumber: 1, size: 200, tableName: 'TipoEdificacion'})
    getCleaningActivitiesStatus({pageNumber: 1, size: 200, tableName: 'ACTIVIDADLIMPIEZAESTADO'})
    setValue('MinutosPromedio', '0')
    setValue('checkHabitacion', true)
    return () => {
      clearCompanies()
      clearClients()
      clearSites()
      clearCampaments()
      clearModules()
      clearRooms()
    }
  }, [])

  useEffect(() => {
    if (companies.length === 1) {
      setValue('CompaniaId', companies[0].value)
      setError('CompaniaId', {})
      getClients({isCombo: true, companiaId: companies[0].value}, 1)
    }
  }, [companies])

  useEffect(() => {
    if (clients.length === 1) {
      setValue('ClienteId', clients[0].value)
      setError('ClienteId', {})
      getSites({isCombo: true, clienteId: clients[0].value}, 1)
    }
  }, [clients])

  useEffect(() => {
    if (sites.length === 1) {
      setValue('SiteId', sites[0].value)
      setError('SiteId', {})
      getCampaments({isCombo: true, siteId: sites[0].value}, 1, {
        all: true,
        value: allValue,
        label: 'TODOS',
      })
    }
  }, [sites])

  useEffect(() => {
    if (campaments.length === 1) {
      setValue('CampamentoId', campaments[0].value)
      setError('CampamentoId', {})
    }
  }, [campaments])

  const getCleaningActivityById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await CREATION_CLEANING_ACTIVITIES_SERVICES.getCleaningActivityById(idToEdit)
        if (data) {
          const {
            CampamentoId,
            SiteId,
            CompaniaId,
            ClienteId,
            TipoAccionId,
            MinutosPromedio,
            ActividadId,
            TipoEdificacionId,
            ModuloId,
            HabitacionId,
            EstadoActividadId,
            Programaciones,
          } = data

          setValue('Id', idToEdit)
          setValue('CampamentoId', CampamentoId)
          setValue('CompaniaId', CompaniaId)
          setValue('ClienteId', ClienteId)
          setValue('SiteId', SiteId)
          setValue('TipoAccionId', TipoAccionId)
          setValue('MinutosPromedio', MinutosPromedio?.toString() || '0')
          setValue('ActividadId', ActividadId || allValue)
          setValue('TipoEdificacionId', TipoEdificacionId)
          setValue('ModuloId', ModuloId)
          setValue('HabitacionId', HabitacionId)
          setValue('EstadoActividadId', EstadoActividadId)
          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            detailRow: {...currentTabItem.detailRow, Programaciones: Programaciones || []},
          }
          changeCurrentTabItem(obj)
          getClients({isCombo: true, companiaId: CompaniaId}, 1)
          getSites({isCombo: true, clienteId: ClienteId}, 1)
          getCampaments({isCombo: true, siteId: SiteId}, 1, {
            all: true,
            value: allValue,
            label: 'TODOS',
          })
          getModules(
            {CampamentoId: CampamentoId, SiteId: SiteId, pageNumber: 1, size: 100},
            {all: true, value: allValue, label: 'TODOS'},
          )
          getRooms(
            {ModuloId: ModuloId, pageNumber: 1, size: 100},
            {all: true, value: allValue, label: 'TODOS'},
          )
        }
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getCleaningActivityById()
    }
  }, [currentTabItem.idToEdit])

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    clearSites()
    setValue('CampamentoId', '')
    clearCampaments()
    setError('CompaniaId', {})
    clearClients()
    clearModules()
    clearRooms()
    getClients({isCombo: true, companiaId: value}, 1)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    clearSites()
    clearCampaments()
    clearModules()
    clearRooms()
    setError('ClienteId', {})
    getSites({isCombo: true, clienteId: value}, 1)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    setError('SiteId', {})
    clearCampaments()
    clearModules()
    clearRooms()
    getCampaments({isCombo: true, siteId: value}, 1, {
      all: true,
      value: allValue,
      label: 'TODOS',
    })
  }

  const handleCampamentChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
    clearModules()
    clearRooms()
    getModules(
      {CampamentoId: value === allValue ? null : value, SiteId: siteId, pageNumber: 1, size: 100},
      {all: true, value: allValue, label: 'TODOS'},
    )
  }

  const handleModuleChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ModuloId', value)
    setError('ModuloId', {})
    clearRooms()
    getRooms(
      {ModuloId: value === allValue ? null : value, pageNumber: 1, size: 100},
      {all: true, value: allValue, label: 'TODOS'},
    )
  }

  useEffect(() => {
    if (typeActions.length > 0) {
      if (inicioFin) {
        setValue('TipoAccionId', inicioFin.value)
        setError('TipoAccionId', {})
        return
      }
    }
  }, [typeActions])

  useEffect(() => {
    if (cleaningActivitiesStatus.length > 0) {
      if (activeStatus) {
        setValue('EstadoActividadId', activeStatus.value)
        setError('EstadoActividadId', {})
        return
      }
    }
  }, [cleaningActivitiesStatus])

  // Re-aplicar valores por defecto después de usar el botón "Limpiar"
  useEffect(() => {
    if (currentTabItem.reset) {
      // Valores base
      setValue('MinutosPromedio', '0')
      setValue('checkHabitacion', false)
      // Defaults dependientes de catálogos ya cargados
      if (typeActions.length > 0 && inicioFin) {
        setValue('TipoAccionId', inicioFin.value)
        setError('TipoAccionId', {})
      }
      if (cleaningActivitiesStatus.length > 0 && activeStatus) {
        setValue('EstadoActividadId', activeStatus.value)
        setError('EstadoActividadId', {})
      }
      // Si hay únicos valores en cascada, restablecerlos
      if (companies.length === 1) {
        setValue('CompaniaId', companies[0].value)
        setError('CompaniaId', {})
      }
      if (clients.length === 1) {
        setValue('ClienteId', clients[0].value)
        setError('ClienteId', {})
      }
      if (sites.length === 1) {
        setValue('SiteId', sites[0].value)
        setError('SiteId', {})
      }
      if (campaments.length === 1) {
        setValue('CampamentoId', campaments[0].value)
        setError('CampamentoId', {})
      }
      // Limpiar flag para no repetir
      const obj: TabLimpiezaModel = {
        ...currentTabItem,
        reset: false,
      }
      changeCurrentTabItem(obj)
    }
  }, [
    currentTabItem.reset,
    typeActions,
    cleaningActivitiesStatus,
    companies,
    clients,
    sites,
    campaments,
  ])

  useEffect(() => {
    if (typeActionWatch && typeActions.length > 0) {
      setShowFieldsStart(true)
      setValue('ModuloId', allValue)
      if (inicioFin && typeActionWatch === inicioFin.value) {
        setTypeActionStart(true)
        setAllTypes(false)
      } else if (ingresoSalida && typeActionWatch === ingresoSalida.value) {
        setTypeActionStart(false)
        setAllTypes(false)
        // Si la accion es INGRESO, SALIDA o INGRESO SALIDA, setear TipoEdificacion a MODULO por defecto
        if (
          (ingreso && typeActionWatch === ingreso.value) ||
          (salida && typeActionWatch === salida.value) ||
          (ingresoSalida && typeActionWatch === ingresoSalida.value)
        ) {
          if (moduloBuilding) {
            setValue('TipoEdificacionId', moduloBuilding.value)
            setError('TipoEdificacionId', {})
          }
        }
      } else if (typeActionWatch === allValue) {
        setAllTypes(true)
        setValue('ActividadId', allValue)
        if (moduloBuilding) {
          setValue('TipoEdificacionId', moduloBuilding.value)
          setError('TipoEdificacionId', {})
        }
      }
    } else {
      setShowFieldsStart(false)
      setTypeActionStart(false)
      setAllTypes(false)
    }
  }, [typeActionWatch, typeActions])

  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    // <ContentForm isEdit={false} title='Datos de Creacion de Actividades de Limpieza'>
    <div className='sdx_form card p-4'>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañia'
            name='CompaniaId'
            data={companies}
            onChangeValue={handleCompanyChange}
            required
            disabled={isDisabled}
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='ClienteId'
            data={clients}
            onChangeValue={handleClientChange}
            required
            disabled={isDisabled}
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Site'
            name='SiteId'
            data={sites}
            onChangeValue={handleSiteChange}
            required
            disabled={isDisabled}
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Campamento'
            name='CampamentoId'
            data={campaments}
            required
            onChangeValue={handleCampamentChange}
            disabled={isDisabled}
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de Acción'
            name='TipoAccionId'
            data={typeActions}
            required
            disabled={isDisabled}
          />
        </div>
        {(allTypes || (showFieldsStart && typeActionStart)) && (
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputNumberWrapper2
              labelText='Tiempo Promedio Estimado (minutos)'
              name='MinutosPromedio'
              textPlaceholder='Escribe los minutos promedio'
              required
            />
          </div>
        )}
        {(allTypes || (showFieldsStart && !typeActionStart)) && (
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Tipo de Edificación'
              name='TipoEdificacionId'
              data={typeBuildings}
              required
              disabled={isDisabled}
            />
          </div>
        )}
        {(allTypes || (showFieldsStart && typeActionStart)) && (
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Actividad de Limpieza'
              name='ActividadId'
              data={cleaningActivities}
              required
              disabled={isDisabled}
            />
          </div>
        )}
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Estado'
            name='EstadoActividadId'
            data={cleaningActivitiesStatus}
            required
          />
        </div>
      </div>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Módulo'
            name='ModuloId'
            data={modules}
            onChangeValue={handleModuleChange}
            disabled={isDisabled}
          />
        </div>
        {!isDisabled && (
          <div className='col-sm-12 col-md-4 col-xl-3 d-flex align-items-center'>
            <CheckWrapper
              name='checkHabitacion'
              nameCheck='Check Habitación'
              className='h-100'
              disabled={isDisabled}
            />
          </div>
        )}
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </div>
    </div>
    // </ContentForm>
  )
}
